import React, { useState } from 'react';
import { availableLanguages } from '../data/translations';
import '../App.css';

const Header = ({ t, language, setLanguage, userTimezone, setSidebarOpen }) => {
    const [showLanguageSelector, setShowLanguageSelector] = useState(false);

    return (
        <header className="header">
            <div className="header-content">
                <button className="hamburger-menu" onClick={() => setSidebarOpen(true)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <h1>{t.title} <span className="year">2026</span></h1>
                <div className="header-actions">
                    <a
                        href="https://buymeacoffee.com/marceloreyes"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-button"
                        title="Buy me a coffee"
                    >
                        <span className="contact-icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ display: 'block' }}
                            >
                                <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                                <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                                <line x1="6" y1="1" x2="6" y2="4"></line>
                                <line x1="10" y1="1" x2="10" y2="4"></line>
                                <line x1="14" y1="1" x2="14" y2="4"></line>
                            </svg>
                        </span>
                        <span className="contact-text">Buy me a coffee</span>
                    </a>
                    <div className="language-selector-wrapper">
                        <button
                            className="language-button"
                            onClick={() => setShowLanguageSelector(!showLanguageSelector)}
                            title={availableLanguages.find(lang => lang.code === language)?.name}
                        >
                            <span className="language-flag">{availableLanguages.find(lang => lang.code === language)?.flag}</span>
                            <span className="language-name">{availableLanguages.find(lang => lang.code === language)?.name}</span>
                        </button>
                        {showLanguageSelector && (
                            <div className="language-dropdown">
                                {availableLanguages.map(lang => (
                                    <button
                                        key={lang.code}
                                        className={`language-option ${language === lang.code ? 'active' : ''}`}
                                        onClick={() => {
                                            setLanguage(lang.code);
                                            setShowLanguageSelector(false);
                                            const newUrl = new URL(window.location.href);
                                            newUrl.searchParams.set('lang', lang.code);
                                            window.history.pushState({}, '', newUrl.toString());
                                        }}
                                    >
                                        {lang.flag} {lang.name}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <p className="subtitle">{t.subtitle} {userTimezone || 'Detectando...'}</p>
        </header>
    );
};

export default Header;
